import { UseFormRegister } from "react-hook-form";

import localeCore from "../../core/locale.core";
import { useTranslation } from "../../core/translation.core";
import useShop from "../../hooks/useShop.hook";
import { LabelAndInput, LabelAndTextArea } from "../reuseables/form.comp";

export interface LocaleInputProps {
  locales: string[];
  label?: string;
  register: UseFormRegister<any>;
  fieldName: string;
  labelCss?: string;
  subLabelCss?: string;
  rowCss?: string;
  required?: boolean;
}

interface LocaleInputStoreProps {
  label?: string;
  register: UseFormRegister<any>;
  fieldName: string;
  labelCss?: string;
  subLabelCss?: string;
  rowCss?: string;
  required?: boolean;
}

export const LocalInputDefaultLocale = ({
  label,
  register,
  fieldName,
  labelCss = "block mb-1",
  subLabelCss = "text-[10px] mt-2",
  rowCss = "grid gap-0 lg:gap-4 lg:grid-flow-col lg:auto-cols-fr",
  required,
}: LocaleInputStoreProps) => {
  const { selectedShop } = useShop();
  if (!selectedShop) return null;

  return (
    <LocaleInput
      locales={selectedShop.locales}
      register={register}
      fieldName={fieldName}
      label={label}
      labelCss={labelCss}
      subLabelCss={subLabelCss}
      rowCss={rowCss}
      required={required}
    />
  );
};

export const LocaleInput = ({
  locales,
  label,
  register,
  fieldName,
  labelCss,
  subLabelCss = "text-[10px] mt-2",
  rowCss = "grid gap-4 lg:grid-flow-col lg:auto-cols-fr",
  required,
}: LocaleInputProps) => {
  const { t, msg } = useTranslation();

  return (
    <div>
      {label && <span className={labelCss}>{label}</span>}
      <div className={rowCss}>
        {locales.map((l) => {
          const locale = l.replace("-", "");

          var name = `${fieldName}.${locale}`;

          return (
            <LabelAndInput
              key={name}
              register={register}
              fieldName={name}
              label={localeCore.getLocaleLabel(l, t, msg) ?? ""}
              topLabelCss="block"
              labelCss={subLabelCss}
              required={required}
            />
          );
        })}
      </div>
    </div>
  );
};

export const LocaleTextAresDefaultLocale = ({ label, register, fieldName }: LocaleInputStoreProps) => {
  const { selectedShop } = useShop();

  if (!selectedShop) return null;

  return (
    <LocaleTextArea
      locales={selectedShop.locales}
      register={register}
      fieldName={fieldName}
      label={label}
      labelCss="block text-xs font-semibold mb-2"
    />
  );
};

export const LocaleTextArea = ({ locales, label, register, fieldName, labelCss = "text-xs font-semibold" }: LocaleInputProps) => {
  const { t, msg } = useTranslation();

  return (
    <label>
      <span className={labelCss}>{label}</span>
      <div className="grid gap-4 lg:grid-flow-col lg:auto-cols-fr">
        {locales.map((l) => {
          const locale = l.replace("-", "");
          var name = `${fieldName}.${locale}`;
          return (
            <div key={name} className="flex-grow">
              <LabelAndTextArea
                rows={10}
                register={register}
                fieldName={name}
                label={localeCore.getLocaleLabel(l, t, msg) ?? ""}
                topLabelCss="block"
                labelCss="text-[10px]"
              />
            </div>
          );
        })}
      </div>
    </label>
  );
};
